import React from 'react';
import { allowedCharLettersForProduct } from '../productPersonalization';
import './monogram-card.css';

/**
 * Compact monogram picker for product cards — one native dropdown, no chip grid.
 */
export default function MonogramLetterSelect({ product, value, onChange, disabled, id = 'monogram-letter' }) {
  const letters = allowedCharLettersForProduct(product);

  return (
    <div className="monogram-card-field">
      <label htmlFor={id} className="monogram-card-field__label">
        <span className="monogram-card-field__mark" aria-hidden>
          ✦
        </span>
        Your letter
      </label>
      <select
        id={id}
        className="form-select form-select-sm monogram-card-field__select"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        aria-required="true"
      >
        <option value="">Choose letter…</option>
        {letters.map((letter) => (
          <option key={letter} value={letter}>
            {letter}
          </option>
        ))}
      </select>
    </div>
  );
}
